import { ResourceBlock } from '@mews-commander/data-access';
import { Stack, Table, TableHeader, TableProvider, useTableState } from '@optimus-web/core';
import { ReportTitle, useResourcesCategoriesQuery } from '../../../common';
import { ResourceBlocksFilterValues } from '../filters';
import { useResourceBlocksTableQuery } from './hooks';
import { useColumns } from './common';

export interface ResourceBlocksTableProps {
    filterValues: ResourceBlocksFilterValues;
    handleResourceBlockClick: (data: ResourceBlock) => void;
}

const emptyTableProps = {
    data: [],
    amountOfRows: 0,
};

export const ResourceBlocksTable = ({ filterValues, handleResourceBlockClick }: ResourceBlocksTableProps) => {
    const { isFetching: isResourcesCategoriesPrefetching } = useResourcesCategoriesQuery();
    const [tableState, setTableState] = useTableState<ResourceBlock>();

    const { startDate, endDate } = filterValues;
    const { data, isFetching } = useResourceBlocksTableQuery({ filterValues, tableState });

    const columns = useColumns({ handleResourceBlockClick });

    const tableProps = data
        ? {
              amountOfRows: data.totalCount ?? 0,
              data: data.resourceBlocks,
          }
        : emptyTableProps;

    return (
        <TableProvider columns={columns} state={tableState} onStateChange={setTableState}>
            <TableHeader title={<ReportTitle startDate={startDate} endDate={endDate} />} />
            <Stack vertical>
                <Table uniqueRowId="id" {...tableProps} loading={isFetching || isResourcesCategoriesPrefetching} />
            </Stack>
        </TableProvider>
    );
};
